import React, { useEffect, useState, useRef } from "react";
import { Radio, Spin, Modal, Checkbox, Switch } from "antd";
import { DownOutlined, RightOutlined, EyeOutlined, CopyOutlined, ExclamationCircleFilled, CloseOutlined } from "@ant-design/icons";
import Layout from "../../Layout";
import "./ManualDataMerging.scss";
import { Link, useNavigate } from "react-router-dom";
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import { mixPostV3, mixGetV2 } from "../../services/mixin";
import useToast from '../../hook/useToast';
import { selectorSourceColumnWarehouse } from '../../store/slices/sourceColumnWarehouseSlice';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';

interface RecordType {
  id: string;
  name: string;
  cccd: string;
  tax: string;
  phones: string[];
  gender: string;
  dob: string;
  email: string;
  type: string;
  job: string;
  addresses: string[];
  district: string;
  city: string;
}

const MergeData: React.FC = () => {
  const [openSections, setOpenSections] = useState<Record<string, boolean>>({ customer: true, contact: true, vehicle: true, invoice: true, interaction: true });
  const toggleSection = (key: string) => setOpenSections(prev => ({ ...prev, [key]: !prev[key] }));
  const [showDiffOnly, setShowDiffOnly] = useState(false);
  const sourceColumnWarehouse = useSelector(selectorSourceColumnWarehouse);
  const navigate = useNavigate()
  const pushToast = useToast();

  const [fields, setFields] = useState([] as any);

  const objFields = fields.reduce((acc: any, field: any) => {
    acc[field.key] = field;
    return acc;
  }, {} as Record<string, typeof fields[0]>);

  const searchParams = new URLSearchParams(window.location.search);
  const ids = searchParams.get('ids') || '';
  const listKey = searchParams.get('list_key') || '';
  const listKeyArr = listKey ? listKey.split(',') : [];
  const conditionFields = fields.filter((f: any) => listKeyArr.includes(f.key));
  const normalFields = fields.filter((f: any) => !listKeyArr.includes(f.key));

  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.manual_merging?.list.map((col: any, index: any) => {
      temp.push({
        label: col.headerName,
        key: col.field,
        emply: true,
        pos: index + 1,
      })
    })
    return temp
  }

  useEffect(() => {
    const tempfileds = [
      ...tableColumns(sourceColumnWarehouse)
      // { key: "cus_name", label: "Tên khách hàng", emply: true, pos: 1 },
      // { key: "cus_dms_id_card_no", label: "CCCD/CMND", emply: true, pos: 2 },
      // { key: "cus_id_tax", label: "Mã số thuế", emply: true, pos: 3 },
      // { key: "cus_tel", label: "Số điện thoại", emply: true, pos: 4 },
      // { key: "cus_gender_name", label: "Giới tính", emply: true, pos: 5 },
      // { key: "cus_birth_day", label: "Ngày sinh", emply: true, pos: 6 },
      // { key: "cus_email", label: "Email", emply: true, pos: 7 },
      // { key: "cus_type_name", label: "Loại khách hàng", emply: true, pos: 8 },
      // { key: "cus_career_name", label: "Nghề nghiệp", emply: true, pos: 9 },
      // { key: "cus_address", label: "Địa chỉ", emply: true, pos: 10 },
      // { key: "cus_district", label: "Quận/Huyện", emply: true, pos: 11 },
      // { key: "cus_province", label: "Tỉnh", emply: true, pos: 12 },
      // { key: "cus_city", label: "Thành phố", emply: true, pos: 13 },
      // { key: "cus_branch_name", label: "Chi nhánh", emply: true, pos: 14 },
      // { key: "cus_channels_name", label: "Kênh khách hàng", emply: true, pos: 15 },
      // { key: "cus_company_representative", label: "Người đại diện công ty", emply: true, pos: 16 },
      // { key: "cus_marital_status", label: "Tình trạng hôn nhân", emply: true, pos: 17 },
      // { key: "cus_route_name", label: "Đơn vị", emply: true, pos: 18 },
      // { key: "vehicle_chassis_no", label: "Số khung", emply: true, pos: 19 },
    ] as any
    if (listKey) {
      const listKeyArr = listKey.split(',');
      const newFields = tempfileds.map((field: any) => {
        if (listKeyArr.includes(field.key)) {
          return { ...field, pos: (listKeyArr.length - listKeyArr.indexOf(field.key)) * -1 };
        }
        return field;
      });
      newFields.sort((a: any, b: any) => a.pos - b.pos);
      setFields(newFields);
    } else {
      setFields(tempfileds);
    }
  }, [listKey]);

  const mergeSections = [
    {
      key: 'contact',
      label: 'Người liên hệ',
      children: [],
    },
    {
      key: 'vehicle',
      label: 'Thông tin xe',
      children: [
        { key: 'xe_so_huu', label: 'Xe sở hữu', dataKey: 'owned_cars' },
        { key: 'xe_su_dung', label: 'Xe sử dụng', dataKey: 'used_cars' },
        { key: 'xe_quan_tam', label: 'Xe quan tâm', dataKey: 'interested_cars' },
      ],
    },
    {
      key: 'invoice',
      label: 'Lịch sử hóa đơn',
      children: [
        { key: 'hoa_don_xe', label: 'Hóa đơn xe', dataKey: 'vehicle_invoices' },
        { key: 'hoa_don_bao_tri', label: 'Hóa đơn bảo trì dịch vụ', dataKey: 'service_invoices' },
      ],
    },
    {
      key: 'interaction',
      label: 'Lịch sử tương tác',
      children: [
        { key: 'cham_soc', label: 'Chăm sóc bán hàng, dịch vụ', dataKey: 'sales_service' },
        { key: 'ho_tro', label: 'Lịch sử hỗ trợ, khiếu nại', dataKey: 'support_history' },
        { key: 'khao_sat', label: 'Thông tin khảo sát', dataKey: 'survey' },
        { key: 'marketing', label: 'Marketing', dataKey: 'marketing' },
      ],
    },
  ];

  const [listData, setListData] = useState<RecordType[]>([]);
  const [relatedData, setRelatedData] = useState<any>({});
  const [rawMergedData, setRawMergedData] = useState<Record<string, any>>({});
  const [objData, setObjData] = useState<any>({});
  const [objHl, setObjHl] = useState<any>({});
  const getMergedData = async () => {
    const res = await mixPostV3('/check/merge_manual_data_v2/', {
      customer_ids: ids.split(','),
    });
    if (res.merged_data && Array.isArray(res.merged_data)) {
      const listNotError = res.merged_data.filter((item: any) => !item.error);
      listNotError.sort((a: any, b: any) => {
        const parseDate = (dateStr: string) => {
          if (!dateStr) return new Date(0);
          const [day, month, year] = dateStr.split('/');
          return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        };

        const dateA = parseDate(a.data?.cus_created_at);
        const dateB = parseDate(b.data?.cus_created_at);

        return dateB.getTime() - dateA.getTime();
      });
      const temp = [] as any
      const obj = {} as any
      const objhl = {} as any
      const objhlreal = {} as any
      listNotError.map((item: any, index: any) => {
        Object.keys(item.data).map((key: any) => {
          if (item.data[key] && objFields[key]) {

            if (objhl[key] === undefined) {
              objhl[key] = [];
              objhlreal[key] = [];
            }

            if (Array.isArray(item.data[key])) {
              if (Array.isArray(item.data[key]) && item.data[key].length > 0) {
                objFields[key].emply = false;
              }
              item.data[key].map((val: any, index2: any) => {
                if (!objhl[key].includes(val) && val) {
                  objhlreal[key].push(`val_${index}_${index2}_${val}`);
                  objhl[key].push(val);
                }
              })
            } else {
              objFields[key].emply = false;
              if (!objhl[key].includes(item.data[key]) && item.data[key]) {
                objhlreal[key].push(`val_${index}_${item.data[key]}`);
                objhl[key].push(item.data[key]);
              }
            }
          }
          if (objFields[key] && !obj[key]) {
            if (Array.isArray(item.data[key])) {
              if (item.data[key].length > 0) {
                obj[key] = `val_${index}_0_${item.data[key][0]}`
              }
            } else {
              if (item.data[key]) {
                obj[key] = `val_${index}_${item.data[key]}`
              }
            }
          }
          return true;
        })
        temp.push({
          ...item.data,
          customer_id: item.customer_id,
          id: item.data.cus_id
        })
        return true
      })
      setObjHl(objhlreal);
      setObjData(obj);
      setListData(temp);

      const rawMap = {} as Record<string, any>;
      listNotError.forEach((item: any) => {
        rawMap[item.data.cus_id || item.customer_id] = item;
      });
      setRawMergedData(rawMap);

      if (res.related_data) {
        setRelatedData(res.related_data);
      }
    }
  }

  useEffect(() => {
    if (ids && fields.length > 0) {
      getMergedData();
    }
  }, [ids, fields]);
  const mergeTable = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!mergeTable.current) return;
    setIsDragging(true);
    setStartX(e.pageX - mergeTable.current.offsetLeft);
    setScrollLeft(mergeTable.current.scrollLeft);
    mergeTable.current.style.cursor = 'grabbing';
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging || !mergeTable.current) return;
    e.preventDefault();
    const x = e.pageX - mergeTable.current.offsetLeft;
    const walk = (x - startX) * 2; // Tốc độ scroll
    mergeTable.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    if (mergeTable.current) {
      mergeTable.current.style.cursor = 'grab';
    }
  };

  const handleMouseLeave = () => {
    if (isDragging) {
      setIsDragging(false);
      if (mergeTable.current) {
        mergeTable.current.style.cursor = 'grab';
      }
    }
  };

  const [waitMerge, setWaitMerge] = useState(false);
  const [showMergeConfirm, setShowMergeConfirm] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(() => localStorage.getItem('merge_dont_show_confirm') === '1');
  const user = useSelector(selectorInfoUser);

  const mergeData = async () => {
    if (waitMerge) return;
    setWaitMerge(true);
    const params = {
      is_user: user.id,
      source_customer_ids: listData.map((item: any) => item.customer_id),
      selected_data: {},
    } as any
    fields.map((field: any) => {
      if (!objData[field.key]) return;
      const arr = objData[field.key]?.toString().split('_')
      if (arr.length > 3) {
        let val = objData[field.key]?.toString().split('_')[3] || ''
        if (val === 'null') val = null;
        const ix = val ? [val] : [];
        if (ix.length > 0) {
          params.selected_data[field.key] = [val]
        }
      } else {
        let val = objData[field.key]?.toString().split('_')[2] || ''
        if (val === 'null') val = null;
        if (val) {
          params.selected_data[field.key] = val
        }
      }
    })
    const res = await mixPostV3('/customer/merge/finalize', { ...params });
    if (res && res.status === 'success') {
      pushToast('Gộp dữ liệu thành công.', "success");
      window.open(`/customer/pooling-data/customer-list/detail?id_sync=${res.new_customer_id}`, '_blank');
      navigate(-1);
    } else {
      pushToast('Gộp dữ liệu thất bại. Vui lòng thử lại sau.', "error");
      setWaitMerge(false);
    }
  }

  const review = async () => {
    const params = {
      is_user: user.id,
      source_customer_ids: listData.map((item: any) => item.customer_id),
      selected_data: {},
    } as any
    fields.map((field: any) => {
      if (!objData[field.key]) return;
      const arr = objData[field.key]?.toString().split('_')
      if (arr.length > 3) {
        let val = objData[field.key]?.toString().split('_')[3] || ''
        if (val === 'null') val = null;
        const ix = val ? [val] : [];
        if (ix.length > 0) {
          params.selected_data[field.key] = [val]
        }
      } else {
        let val = objData[field.key]?.toString().split('_')[2] || ''
        if (val === 'null') val = null;
        if (val) {
          params.selected_data[field.key] = val
        }
      }
    })
    sessionStorage.setItem('merge_review_data', JSON.stringify(params));
    window.open('/customer/pooling-data/customer-list/detail-review', '_blank');
    return
  }

  // Lấy danh sách điều kiện gộp
  const [detailMigrations, setDetailMigrations] = useState({} as any)
  let wait1 = false
  const getMigrations = async () => {
    if (wait1) {
      return
    }
    wait1 = true
    const res = await mixGetV2(`/api/v1/be/data_migration/${searchParams.get('migration')}`)
    wait1 = false
    if (res.status) {
      setDetailMigrations(res.data)
    }
  }
  useEffect(() => {
    getMigrations()
  }, [])

  const coppyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      pushToast('Đã sao chép', 'success')
    })
  }

  const recalcHighlights = (data: any[]) => {
    const obj = {} as any;
    const objhl = {} as any;
    const objhlreal = {} as any;
    data.map((item: any, index: any) => {
      Object.keys(item).map((key: any) => {
        if (item[key] && objFields[key]) {
          if (objhl[key] === undefined) {
            objhl[key] = [];
            objhlreal[key] = [];
          }
          if (Array.isArray(item[key])) {
            if (item[key].length > 0) {
              objFields[key].emply = false;
            }
            item[key].map((val: any, index2: any) => {
              if (!objhl[key].includes(val) && val) {
                objhlreal[key].push(`val_${index}_${index2}_${val}`);
                objhl[key].push(val);
              }
            })
          } else {
            objFields[key].emply = false;
            if (!objhl[key].includes(item[key]) && item[key]) {
              objhlreal[key].push(`val_${index}_${item[key]}`);
              objhl[key].push(item[key]);
            }
          }
        }
        if (objFields[key] && !obj[key]) {
          if (Array.isArray(item[key])) {
            if (item[key].length > 0) {
              obj[key] = `val_${index}_0_${item[key][0]}`;
            }
          } else {
            if (item[key]) {
              obj[key] = `val_${index}_${item[key]}`;
            }
          }
        }
        return true;
      })
      return true;
    });
    setObjHl(objhlreal);
    setObjData(obj);
  };

  const removeCustomer = (customerId: string) => {
    if (listData.length <= 2) {
      pushToast('Cần ít nhất 2 khách hàng để gộp dữ liệu.', 'warning');
      return;
    }
    const newList = listData.filter((item: any) => item.id !== customerId);
    setListData(newList);
    recalcHighlights(newList);
  }

  const isFieldIdentical = (fieldKey: string) => {
    if (!objHl[fieldKey] || objHl[fieldKey].length <= 1) return true;
    return false;
  };

  const openDetail = (customerId: string, section: string) => {
    window.open(`/customer/pooling-data/customer-list/detail?id_sync=${customerId}&section=${section}`, '_blank');
  };

  const renderFieldRow = (field: any) => {
    if (showDiffOnly && isFieldIdentical(field.key)) return null;
    return (
      <div key={field.key} className={`merge-row ${objFields[field.key]?.emply ? 'emty-row' : ''}`}>
      <div className="merge-label fw-500-cl-344054">{field.label}</div>
      {
        listData.map((r: any, index0: any) => (
          Array.isArray(r[field.key]) ?
            <div key={`${r.id}${field.key}`} className="merge-col">
              {(r[field.key as keyof RecordType] as string[] || []).map((val, index) => (
                <div key={index} className={`sub-value ${objHl[field.key] && objData[field.key] !== `val_${index0}_${index}_${r[field.key][index]}` && objHl[field.key].includes(`val_${index0}_${index}_${r[field.key][index]}`) ? 'val-hlx' : ''}`}>
                  <Radio
                    checked={objData[field.key] === `val_${index0}_${index}_${r[field.key][index]}`}
                    className='rs-radio'
                    onChange={() => {
                      setObjData((prev: any) => ({
                        ...prev,
                        [field.key]: `val_${index0}_${index}_${r[field.key][index]}`
                      }))
                    }}
                  >
                    {val}
                  </Radio>
                </div>
              ))}
            </div>
            :
            <div key={`${r.id}${field.key}`} className="merge-col">
              <div className={`sub-value ${objHl[field.key] && objData[field.key] !== `val_${index0}_${r[field.key]}` && objHl[field.key].includes(`val_${index0}_${r[field.key]}`) ? 'val-hlx' : ''} ${!r[field.key] ? 'd-none' : ''}`}>
                <Radio
                  checked={objData[field.key] === `val_${index0}_${r[field.key]}`}
                  onChange={() => {
                    setObjData((prev: any) => ({
                      ...prev,
                      [field.key]: `val_${index0}_${r[field.key]}`
                    }))
                  }}
                  className="rs-radio"
                >
                  {String(r[field.key] ?? "Không xác định")}
                </Radio>
              </div>
            </div>
        ))
      }
    </div>
    );
  };

  return (
    <Layout>
      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: <Link to="/customer/pooling-data">Khách hàng</Link>, },
          { title: <Link to="/customer/pooling-data/pooling-data-auto">Kiểm tra dữ liệu trùng theo điều kiện</Link>, },
          { title: 'Gộp dữ liệu thủ công', },
        ]}
        title='Gộp dữ liệu thủ công'
        historyBack='/customer/pooling-data/pooling-data-auto'
        className="gutter-block-end"
      />
      <div className="customer-list">
        <div className="merge-header filter-block v2">
          <div className="merge-header-row1">
            <div className="merge-warning">
              <div className="icon">
                <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 3.82812C8.38359 3.82812 3.82812 8.38359 3.82812 14C3.82812 19.6164 8.38359 24.1719 14 24.1719C19.6164 24.1719 24.1719 19.6164 24.1719 14C24.1719 8.38359 19.6164 3.82812 14 3.82812ZM13.125 8.09375C13.125 7.97344 13.2234 7.875 13.3438 7.875H14.6562C14.7766 7.875 14.875 7.97344 14.875 8.09375V15.5312C14.875 15.6516 14.7766 15.75 14.6562 15.75H13.3438C13.2234 15.75 13.125 15.6516 13.125 15.5312V8.09375ZM14 20.125C13.6565 20.118 13.3295 19.9766 13.0891 19.7312C12.8487 19.4859 12.714 19.156 12.714 18.8125C12.714 18.469 12.8487 18.1391 13.0891 17.8938C13.3295 17.6484 13.6565 17.507 14 17.5C14.3435 17.507 14.6705 17.6484 14.9109 17.8938C15.1513 18.1391 15.286 18.469 15.286 18.8125C15.286 19.156 15.1513 19.4859 14.9109 19.7312C14.6705 19.9766 14.3435 20.118 14 20.125Z" fill="#FFF7E6" />
                  <path d="M14 1.75C7.23516 1.75 1.75 7.23516 1.75 14C1.75 20.7648 7.23516 26.25 14 26.25C20.7648 26.25 26.25 20.7648 26.25 14C26.25 7.23516 20.7648 1.75 14 1.75ZM14 24.1719C8.38359 24.1719 3.82812 19.6164 3.82812 14C3.82812 8.38359 8.38359 3.82812 14 3.82812C19.6164 3.82812 24.1719 8.38359 24.1719 14C24.1719 19.6164 19.6164 24.1719 14 24.1719Z" fill="#FA8C16" />
                  <path d="M13.3438 15.75H14.6562C14.7766 15.75 14.875 15.6516 14.875 15.5312V8.09375C14.875 7.97344 14.7766 7.875 14.6562 7.875H13.3438C13.2234 7.875 13.125 7.97344 13.125 8.09375V15.5312C13.125 15.6516 13.2234 15.75 13.3438 15.75ZM12.6875 18.8125C12.6875 19.1606 12.8258 19.4944 13.0719 19.7406C13.3181 19.9867 13.6519 20.125 14 20.125C14.3481 20.125 14.6819 19.9867 14.9281 19.7406C15.1742 19.4944 15.3125 19.1606 15.3125 18.8125C15.3125 18.4644 15.1742 18.1306 14.9281 17.8844C14.6819 17.6383 14.3481 17.5 14 17.5C13.6519 17.5 13.3181 17.6383 13.0719 17.8844C12.8258 18.1306 12.6875 18.4644 12.6875 18.8125Z" fill="#FA8C16" />
                </svg>
              </div>
              <span>{detailMigrations.describe || detailMigrations.name}</span>
            </div>
          </div>
          <div className="merge-header-row2">
            {conditionFields.length > 0 && (
              <div className="merge-condition-names">
                <span>Điều kiện gộp:</span> <span>{detailMigrations.name}</span>
              </div>
            )}
            <div className="merge-diff-toggle">
              <Switch checked={showDiffOnly} onChange={setShowDiffOnly} />
              <span>Chỉ hiển thị giá trị khác nhau</span>
            </div>
          </div>
        </div>
      </div>
      <div className="merge-wrapper">
        <div
          className="merge-table"
          ref={mergeTable}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}
        >
          {/* Header */}
          <div className="merge-row merge-title-row">
            <div className="merge-label">Trường dữ liệu</div>
            {listData.map((r: any, index: any) => (
              <div className="merge-col" key={r.id}>
                <div className="merge-col-header">
                  <div className="merge-id-select">
                    Ngày tạo: {r.cus_created_at || 'Không xác định'}
                  </div>
                  <CloseOutlined className="merge-col-remove" onClick={() => removeCustomer(r.id)} />
                </div>
                <div className="merge-id-select" onClick={() => coppyToClipboard(r.cus_crm)}>
                  CID: {r.cus_crm}
                </div>
              </div>
            ))}
          </div>

          {/* Condition Fields */}
          {conditionFields.length > 0 && conditionFields.map(renderFieldRow)}

          {/* Section */}
          <div className="merge-row">
            <div className="merge-label" onClick={() => toggleSection('customer')}>
              <div className="merge-section">{openSections.customer ? <DownOutlined className="arrow" /> : <RightOutlined className="arrow" />} Thông tin khách hàng</div>
            </div>
            {listData.map((item: any) => (
              <div key={item.id} className="merge-col"></div>
            ))}
          </div>

          {/* Content Rows */}
          {openSections.customer && normalFields.map(renderFieldRow)}

          {/* Related Sections */}
          {mergeSections.map((section) => (
            <React.Fragment key={section.key}>
              <div className="merge-row">
                <div className="merge-label" onClick={() => toggleSection(section.key)}>
                  <div className="merge-section">{openSections[section.key] ? <DownOutlined className="arrow" /> : <RightOutlined className="arrow" />} {section.label}</div>
                </div>
                {listData.map((item: any, idx: number) => (
                  <div key={item.id} className="merge-col">
                    {idx === 0 && <span className="merge-col-note">Tất cả dữ liệu trong mục này sẽ được gộp chung</span>}
                  </div>
                ))}
              </div>
              {openSections[section.key] && section.children.map((child) => (
                <div key={child.key} className="merge-row">
                  <div className="merge-label fw-500-cl-344054">
                    {child.label}{listData.length > 0 && relatedData?.[listData[0]?.id]?.[child.dataKey] !== undefined
                      ? ` (${listData.reduce((sum: number, r: any) => sum + (relatedData?.[r.id]?.[child.dataKey] || 0), 0)})`
                      : ''}
                  </div>
                  {listData.map((r: any) => (
                    <div key={`${r.id}_${child.key}`} className="merge-col">
                      <span
                        className="merge-detail-link"
                        style={{ cursor: 'pointer' }}
                        onClick={() => openDetail(r.id, child.dataKey)}
                      >
                        <EyeOutlined /> Xem chi tiết
                      </span>
                    </div>
                  ))}
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="merge-bottom-actions">
        <div className="btn-input btn-outline" onClick={review}>
          <div className="text">Xem trước dữ liệu</div>
        </div>
        <div className="btn-input btn-text" onClick={() => {
          if (dontShowAgain) {
            mergeData();
          } else {
            setShowMergeConfirm(true);
          }
        }}>
          <div className="text">Gộp dữ liệu {waitMerge && <Spin className="spin-custom-color" />}</div>
        </div>
      </div>
      <Modal
        open={showMergeConfirm}
        onCancel={() => setShowMergeConfirm(false)}
        title="Bạn có chắc chắn gộp dữ liệu khách hàng?"
        footer={null}
        centered
        className="merge-confirm-modal"
      >
        <div className="merge-confirm-body">
          <div className="merge-confirm-icon">
            <svg width="70" height="62" viewBox="0 0 70 62" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M69.666 57.5L37.166 1.25C36.6817 0.414063 35.8457 0 35.002 0C34.1582 0 33.3145 0.414063 32.8379 1.25L0.337917 57.5C-0.62302 59.1719 0.580104 61.25 2.50198 61.25H67.502C69.4238 61.25 70.627 59.1719 69.666 57.5ZM32.502 23.125C32.502 22.7812 32.7832 22.5 33.127 22.5H36.877C37.2207 22.5 37.502 22.7812 37.502 23.125V37.5C37.502 37.8438 37.2207 38.125 36.877 38.125H33.127C32.7832 38.125 32.502 37.8438 32.502 37.5V23.125ZM35.002 50.625C34.0207 50.605 33.0863 50.2011 32.3994 49.5C31.7125 48.7989 31.3277 47.8565 31.3277 46.875C31.3277 45.8935 31.7125 44.9511 32.3994 44.25C33.0863 43.5489 34.0207 43.145 35.002 43.125C35.9833 43.145 36.9176 43.5489 37.6046 44.25C38.2915 44.9511 38.6762 45.8935 38.6762 46.875C38.6762 47.8565 38.2915 48.7989 37.6046 49.5C36.9176 50.2011 35.9833 50.605 35.002 50.625V50.625Z" fill="#F5222D"/> </svg>
          </div>
          <p className="merge-confirm-text">
            Hệ thống sẽ tiến hành gộp dữ liệu khách hàng, dữ liệu khách hàng xuất hiện ở dòng đầu tiên sẽ được xem là dữ liệu chính, các hồ sơ ở các dòng sau được xử lý như dữ liệu phụ và chỉ dùng để bổ sung thông tin.
          </p>
          <Checkbox
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
          >
            Không thông báo nhắc lại lần sau
          </Checkbox>
        </div>
        <div className="merge-confirm-footer">
          <span className="merge-confirm-cancel" onClick={() => setShowMergeConfirm(false)}>Huỷ</span>
          <div className="btn-input btn-primary merge-confirm-ok" onClick={() => {
            if (dontShowAgain) {
              localStorage.setItem('merge_dont_show_confirm', '1');
            }
            setShowMergeConfirm(false);
            mergeData();
          }}>
            <div className="text">Gộp dữ liệu</div>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default MergeData;
